import logo from './logo.svg';
import './App.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from './components/Home';
import TeamDesk from './components/TeamDesk'

import MultiForm from './components/MultiForm';

function App() {
  return (
  <Router>
     <Routes>

      <Route path='/' exact element={<Home/>}/>
      <Route  path='/info' element = {< TeamDesk />} />
      
      <Route  path='/support' element = {< MultiForm />} />
     </Routes>
  
  </Router>
  );
}

export default App;
